export default {
  title_1_1: 'Secret',
  title_1_2: 'Safe Box',
  desc_1_2: '堅牢・安全・使いやすい',

  title_2_1: '全く新しい',
  title_2_2: 'デザイン',
  desc_2_1:
    '全面レーザー製造工程を採用し、パネルを厚くして保護性能を強化',
  desc_2_2: 'ねじロックと安全ロックを増設し、よりタイトにフィット',
  desc_2_3: '12語ニーモニック2セットに同時対応',
  desc_2_4:
    '全面レーザー製造、厚いパネルで保護力向上／ねじ・安全ロック増設で高い密着性／12語ニーモニック2セット対応',

  title_3_1_1: '驚きの',
  title_3_1_2: '三重耐性',
  desc_3_1:
    '筐体は304ステンレス鋼の精密製造で、耐火性・耐熱性・耐腐食性を備える',
  desc_3_2: '防水',
  desc_3_3_1: '厳選した304ステンレス素材',
  desc_3_3_2: '防水かつ耐腐食',
  desc_3_3_3: '保管環境に優しい',
  desc_3_3_4: 'キーを簡単に保護',
  desc_3_4: '耐火',
  desc_3_5_1: '非常に高い融点',
  desc_3_5_2: '優れた耐火性能と耐性',
  desc_3_5_3: '思わぬ火災時にも',
  desc_3_5_4: 'あなたのキーを守る',
  desc_3_6: '耐衝撃',
  desc_3_7_1: '高強度製造プロセス',
  desc_3_7_2: '厚いパネルで高い密着性',
  desc_3_7_3: '不意の衝突時にも',
  desc_3_7_4: '内部のすべての文字をしっかり守る',

  title_4_1: 'アルファベットパネル',
  desc_4_1_1: 'アルファベットパネル Pro 版',
  desc_4_1_2: 'より便利に、より効率的に',
  desc_4_2_1:
    '新設計で多様なニーズに対応。6枚のパネルを分解して351個のブロックを作成可能',
  desc_4_2_2:
    '大文字・小文字に対応。数字と記号も追加',
  desc_4_2_3:
    '両面デザインで合計702文字を表示可能',
  desc_4_3: '351 ブロック',
  desc_4_4: '大文字 / 小文字',
  desc_4_5: '数字 / 記号',
  desc_4_6: '両面対応',

  title_5_1: '操作図',
  desc_5_1:
    'Web拡張ウォレットに対応。TokenPocket と完全適合し、安全性と使いやすさを両立。',
  desc_5_2: 'ステップ 01',
  desc_5_3: '前面パネルを扇状に開き、反時計回りに開放',
  desc_5_4: 'ステップ 02',
  desc_5_5: 'ドライバーで 5 本のねじをゆるめる',
  desc_5_6: 'ステップ 03',
  desc_5_7: 'カバーパネルを持ち上げる',
  desc_5_8: 'ステップ 04',
  desc_5_9: '文字ブロックをスロットに挿入',
  desc_5_10: 'ステップ 05',
  desc_5_11:
    '確認後、前面パネルを閉じて 5 本のねじを締める',

  title_6_1: '製品仕様 / パッケージ',
  desc_6_1: 'Secret Box Pro',
  desc_6_2:
    '従来の紙写しに比べ、安全性と利便性を両立。簡単に分解・組立でき、文字ブロックの配置も素早く簡単。',
  desc_6_3: 'アルファベットパネル',
  desc_6_4:
    '従来の紙写しに比べ、安全性と利便性を両立。簡単に分解・組立でき、文字ブロックの配置も素早く簡単。',
  desc_6_5: 'EVA バッグ',
  desc_6_6:
    '従来の紙写しに比べ、安全性と利便性を両立。簡単に分解・組立でき、文字ブロックの配置も素早く簡単。',
  desc_6_7: '冊子/ねじ/ドライバー',
  desc_6_8:
    '従来の紙写しに比べ、安全性と利便性を両立。簡単に分解・組立でき、文字ブロックの配置も素早く簡単。',

  title_7_1: '技術仕様',
  title_7_2: '特長と使い方',
  desc_7_1: 'Secret Box 仕様',
  desc_7_2: 'サイズ',
  desc_7_3: '重量',
  desc_7_4: 'アルファベットパネル仕様',
  desc_7_5: '3枚1セット、合計351個の文字ブロック',
  desc_7_6: '複数セットのニーモニックに対応',
  desc_7_7:
    'BIP39 に準拠し、12語×2セット、または18/24語×1セットに対応',
  desc_7_8: 'オフライン保管',
  desc_7_9:
    'オフライン保管により、Secret Box Pro はネット経由での秘密鍵窃取の可能性を排除',
  desc_7_10: '高品質素材',
  desc_7_11:
    '堅牢なステンレス素材はニーモニックの長期保存に最適で、紛失の悩みから解放します。',
};
